import React from 'react';
import { v4 as uuid } from 'uuid';

import IllustrationThumb from 'components/IllustrationThumb';
import GalleryGrid from 'components/GalleryGrid';

export default function renderLoaders() {
  const loaders = [];

  for (let i = 0; i < 16; i++) {
    loaders.push(<IllustrationThumb.Loader key={uuid()} />);
  }

  return <GalleryGrid>{loaders}</GalleryGrid>;
}
